<div *ngIf="toast" class="toast-container" [ngClass]="toast.type" @fadeIn>
     <mat-icon class="toast-icon" [ngClass]="toast.type">
          <ng-container [ngSwitch]="toast.type">
               <ng-container *ngSwitchCase="'success'">check_circle</ng-container>
               <ng-container *ngSwitchCase="'error'">error</ng-container>
               <ng-container *ngSwitchCase="'info'">info</ng-container>
               <ng-container *ngSwitchCase="'warning'">warning</ng-container>
          </ng-container>
     </mat-icon>
     <span class="toast-message">{{ toast.message }}</span>
     <mat-icon class="toast-close" (click)="closeToast()">close</mat-icon>
</div>